import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Payment, Transaction } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { Subscription } from 'rxjs';
import { createMerchantReturnUrl, validateUserDevice } from 'src/app/shared/helps/helps';
import { ClaroPayService } from 'src/app/services/claro-pay.service';
import { ResponseModel } from 'src/app/models/response';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { AlertService } from 'src/app/services/alert.service';
import { Router } from '@angular/router';
import QRCode from 'qrcode';
@Component({
    selector: 'app-wallet-claro-pay',
    templateUrl: './wallet-claro-pay.component.html',
    styleUrls: ['./wallet-claro-pay.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WalletClaroPayComponent implements OnInit {
    @Input() info: Payment;
    @Output() CLAROPAY = new EventEmitter();

    loading: boolean;
    transaction: Transaction;
    template: string;
    orderID: string;
    urlReturnMerchant: string;
    isMobileDevice = false;
    generalConstants = GENERAL_CONSTANTS;
    errorsClaroPay = GENERAL_CONSTANTS.RESPONSE_ERROR_CLARO_PLAY;
    token: string;
    urlToClaroPay: string;
    claroOrderId: string;
    subscriptionTimer: Subscription;

    constructor(
        private readonly authService: AuthService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly claroPayService: ClaroPayService,
        private readonly alertService: AlertService,
        private readonly router: Router
    ) { }
    /**
     * @description Function that initializes the component
     */
    ngOnInit(): void {
        this.loading = false;
        this.onActivate();
        this.template = this.info.template;
        this.orderID = this.authService.getOrderID();
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.isMobileDevice = this.validMobileDevice();
        this.urlReturnMerchant = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);
        this.createClaroPayLink();
    }

    /**
     * @description createClaroPayLink Function to create the payment link of Claro pay
     */
    createClaroPayLink() {
        this.loading = true;
        this.token = this.tokenServiceService.getToken();
        let requestBody = {
            token: this.token,
        };
        this.claroPayService.createClaroPayLink(requestBody).subscribe({
            next: (res: ResponseModel) => {
                if (res.CODE === this.generalConstants.OK_RESPONSE_CODE) {
                    this.urlToClaroPay = res.DATA['paymentLink'];
                    this.claroOrderId = res.DATA['claroOrderId'];
                    this.generateQrCode();
                    this.loading = false;
                    return;
                }
                this.alertService.showAlert(res.TEXT, 'warning', this.errorsClaroPay.GENERAL_ERROR);
                this.loading = false;
            },
            error: (_) => {
                this.alertService.showAlert(this.errorsClaroPay.GENERAL_ERROR);
                this.loading = false;
            },
        });
    }
    /**
     * @description generateQrCode QR code development for ClaroPay
     */
    generateQrCode() {
        try {
            QRCode.toCanvas(document.getElementById('canvas'), this.urlToClaroPay, { errorCorrectionLevel: 'H' }, function (error) {
                if (error) this.alertService.showAlert(this.errorsClaroPay.ERROR_CREATING_QR_CODE);
            });
        } catch (_) {
            this.alertService.showAlert(this.errorsClaroPay.ERROR_CREATING_QR_CODE);
        }
    }

    /**
     *
     * @description onResize Validate screen size change
     */
    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMobileDevice = this.validMobileDevice();
        this.generateQrCode();
    }
    /**
     *
     * @description ValidMobileDevice validate if user has mobile device
     * @returns
     */
    validMobileDevice() {
        return validateUserDevice();
    }

    /**
     * @description Function that returns to payment methods
     */
    changeMethod() {
        this.CLAROPAY.emit();
    }

    /**
     * @description onActivate
     */
    onActivate() {
        window.scroll(0, 0);
    }

    /**
     * @description Function that validates claroPay Steps
     */
    async validateClaroSteps() {
        this.loading = true;
        if (this.isMobileDevice) {
            this.loading = false;
            window.location.href = this.urlToClaroPay;
            return;
        }
        this.router.navigate(['checkout/checkOrderStatus'], { queryParams: { token: this.token, claroOrderId: this.claroOrderId } });
        this.loading = false;
    }
}
